import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_SESSIONS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getTransactionReportListAPI: any = createAsyncThunk(
  "getTransactionReportList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(CHARGING_SESSIONS, {
        headers: commonHead,
        params: params,
      });
      return { transactionReport: res };
    } catch (error: any) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
    }
  }
);
